<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div class="list-header">
    <span class="list-header__label"> Available </span>
    <span class="list-header__label"> Selected </span>
</div>
<div class="custom-list">
    <div class="custom-list__col">
        <div class="custom-list__search">
            <button windeActionIcon>
                <sui-svg-icon class="search" icon="search" windeGrey />
            </button>
            <input
                (keyup)="searchInAvailableList()"
                [(ngModel)]="searchAvailableVal"
                class="custom-list__search-inp"
                placeholder="search"
                type="text"
            />
            <button
                (click)="searchAvailableVal = ''; getAvalibleList()"
                [hidden]="!searchAvailableVal || searchAvailableVal === ''"
                windeActionIcon
            >
                <sui-svg-icon icon="cross" windeRed />
            </button>
        </div>
        <ul (dragover)="dragOver($event)" (drop)="drop($event)" class="custom-list__box custom-list__box--available">
            @for (item of availableListCopy; track item) {
                <li
                    (click)="toggleSelect(checkedAvailable, item)"
                    (dragend)="dragEnd($event)"
                    (dragstart)="drag($event, item)"
                    (keydown)="toggleSelect(checkedAvailable, item)"
                    [draggable]="!isReadonlyMode"
                    [ngClass]="{ active: checkInList(checkedAvailable, item) !== -1 && !isReadonlyMode }"
                    class="custom-list__item"
                    id="item-{{ item.id }}"
                >
                    {{ item[this.displayName] }}
                </li>
            }
        </ul>
    </div>

    <div class="custom-list__functions">
        <button
            (click)="listItemsAction('copy')"
            [disabled]="tooltipsAreDisabled"
            [hidden]="isReadonlyMode"
            position="right"
            suiTooltip
            tooltipText="{{ 'gtthApp.customListBox.button.copy' | translate }}"
            windeActionIcon
        >
            <sui-svg-icon icon="angle-right" windeGrey />
        </button>
        <button
            (click)="listItemsAction('copy', true)"
            [disabled]="tooltipsAreDisabled"
            [hidden]="isReadonlyMode"
            position="right"
            suiTooltip
            tooltipText="{{ 'gtthApp.customListBox.button.copyAll' | translate }}"
            windeActionIcon
        >
            <sui-svg-icon icon="angle-double-right" windeGrey />
        </button>
        <button
            (click)="listItemsAction('remove')"
            [disabled]="tooltipsAreDisabled"
            [hidden]="isReadonlyMode"
            position="right"
            suiTooltip
            tooltipText="{{ 'gtthApp.customListBox.button.remove' | translate }}"
            windeActionIcon
        >
            <sui-svg-icon icon="angle-left" windeGrey />
        </button>
        <button
            (click)="listItemsAction('remove', true)"
            [disabled]="tooltipsAreDisabled"
            [hidden]="isReadonlyMode"
            position="right"
            suiTooltip
            tooltipText="{{ 'gtthApp.customListBox.button.removeAll' | translate }}"
            windeActionIcon
        >
            <sui-svg-icon icon="angle-double-left" windeGrey />
        </button>
    </div>

    <div class="custom-list__col">
        <ul (dragover)="dragOver($event)" (drop)="drop($event)" class="custom-list__box custom-list__box--selected">
            @for (item of selectedList; track item) {
                <li
                    (click)="toggleSelect(checkedSelected, item)"
                    (dragend)="dragEnd($event)"
                    (dragstart)="drag($event, item)"
                    (keydown)="toggleSelect(checkedSelected, item)"
                    [draggable]="!isReadonlyMode"
                    [ngClass]="{ active: checkInList(checkedSelected, item) !== -1 && !isReadonlyMode }"
                    class="custom-list__item"
                    id="item-{{ item.id }}"
                >
                    {{ item[this.displayName] }}
                </li>
            }
        </ul>
    </div>
</div>

<div class="row">
    @if (!isValid && isShowError) {
        <small class="col-6 offset-md-6 text-danger">
            {{ validationMessage }}
        </small>
    }
</div>

@if (hasIncluded) {
    <div class="included-section row">
        <div class="col-6 form-group">
            <span class="form-label"> Included </span>
            <select (change)="changeIncluded()" [(ngModel)]="includedItemId" class="form-control" id="included" name="included">
                <option [ngValue]="undefined">Not selected</option>
                @for (item of availableList; track item) {
                    <option [ngValue]="item.id">{{ item[displayName] }}</option>
                }
            </select>
        </div>
    </div>
}
